/* eslint-disable */
import cx from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';

import { useToggleListItem } from '../../../../hooks/useToggleListItem';
import { CameraList } from './CameraList';

import { PreviewRenderForm } from '../components/camera/PreviewRenderForm';
import dropdownArrow from '../../../../assets/images/arrow-down-white.svg';
import { icons } from '../../../../assets';

const { CloseIconSmall, ColouredCrownIcon } = icons;
import {
  MAX_RESOLUTION,
  MIN_RESOLUTION,
  RP_TYPE,
} from '../../../../config/constant/unityConstants';
import { errorToast } from '../../../../helpers/toastHelper';
import { LockedInput } from '../LockedInput/LockedInput';
import styles from './RenderPreviewDialog.module.scss';
import { SelectFormGroupV2 } from '../../../../common/SelectFormGroup';
import {
  decimals,
  getLocalStorage,
  isUserComingFromWebsite,
  openFormInCaseOfNewOrgAndFreemiumUser,
  scaleResolution,
} from '../../../../helpers/jsHelper';
import Button from '../../../Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectDefaultDpi,
  selectDpiOptions,
} from '../../../../redux/slicers/globalRenderingInfoSlicer';
import { PermissionArea } from '../../../../common/PermissionArea';
import { PERMISSION } from '../../../../constants/permissionConstants';
import { useStaticPermissions } from '../../../../hooks/usePermissions';
import { EMAIL_VERIFIED, LIVE_FURNISH } from '../../../../constants/projectConstants';
import { useUserContext } from '../../../../contexts/UserContext';
import {
  DEFAULT_CAMERA_PX_VALUE,
  FREE_CREDITS_RESOLUTION_LIMIT,
  MAX_PREVIEW_RESOLUTION,
  UPGRADE_POPUP_CURATOR,
} from '../../../../constants/constants';
import {
  imagePaymentFormPopupActions,
  selectIsAmountForRenderSufficient,
  selectOrgAvailableBalance,
  selectSubscriptionPlanExpiredPerImagePrice,
  selectPerImagePremiumPrice,
  selectPerImageUhdPrice,
  selectRenderingPriceInfo,
} from '../../../../redux/slicers/imagePaymentFormPopupSlicer';
import { apiGetOrganizationBalance, apiGetRenderingPriceInfo } from '../../../../helpers/api';
import { MoreInfo } from './MoreInfo';
import { openInvite, setOpen } from '../../../../redux/slicers/camera/renderPreviewPoppupSlicer';
import { getMaxResolution } from '../../../../helpers/unityHelper';
import { setCuratorLoader } from '../../../../redux/slicers/admin/curatorSlicer';
import { selectGamificationTooltipData } from '../../../../redux/slicers/gamificationTooltipSlicer';
import { isUserOnboarding, setTooltipData } from '../../../gamificationTooltip/helpers';
import {
  selectAvailable3DModelUploadLimit,
  selectAvailable3DModelVariationsWithoutDivide,
  selectUserActivePlanSubscriptionAI,
} from '../../../../redux/slicers/subscriptionSlicer';
import { setClientSubscriptionPlans } from '../../../../api/subscription/subscription';
import {
  selectSegmentData,
  setSignupPopOpen,
  setSegmentData,
  setSignupPopOpenedFrom,
} from '../../../../redux/slicers/uiSlicer';
import { navigateToUpgradePlan } from '../../../../screens/subscriptionComponents/subscriptionHelper';
import { useVerifyEmail } from '../../../../common/VerifyYourEmail';
import { userPilotEvents } from '../../../../common/Userpilot/userpilotHelper';
import UpgradeForMore from '../../../popups/UpgradeForMore';
import useCurrentOrganizationInfo from '../../../../hooks/useCurrentOrganizationInfo';
import { CheckedIcon, LeftArrowIconV3 } from '../../../../assets/icons';

import { Input } from '../../../../common';
import { CONFIGURATOR_NAME_MAX_LENGTH } from '../../../../constants/validationConstants';
import { sanitizeNameInConfigurator } from '../../../Configurator/utils';
import { ElipsisTooltip } from '../../../../common/ElipsisTooltip';

const { HelpIconQuestionMark } = icons;

let credits = 0;

export const ProduceImageDialogUI = ({
  dialogClassName,
  contentClassName,
  title,
  onClose,
  show,
  cameraList,
  popupType,
  onSubmit,
  onCameraResolutionChange,
  onCameraClick,
  loading,
  isSiloRoom,
  onLockToggle,
  setLoading,
  hasMetadata,
  resolutionPresets,
  lockedRatio,
  showLicenseTab = false,
  hideFreeLicenseView,
  isCreditsAvailable = false,
  isBuilder = false,
  builderWithTemplates = {},
  setBuilderWithTemplates,
  templatesData,
}) => {
  const dispatch = useDispatch();
  const {
    ids: selectedCameraIds,
    toggleItem,
    toggleAll,
    resetSelectedItems,
    allSelected,
  } = useToggleListItem({ items: cameraList });
  const [selectedCameraId, setSelectedCameraId] = useState(null);
  const { hasPermission } = useStaticPermissions();
  const { handleResend } = useVerifyEmail();
  const {
    isFreemiumUser,
    freeCredits,
    isFreemiumOrOldSubscriptionUser,
    isPremiumUser,
    subscription_expiry,
    isPackOrganization,
    isUnlimitedRendering,
    updateUserData,
    isGuestLogin,
    isNewSubscriptionPlan
  } = useUserContext();
  const { isOldSubscriptionUser, isOldPremiumUserWithNoPlan, hideNewPlans } =
    useCurrentOrganizationInfo();
  const dpiOptions = useSelector(selectDpiOptions);
  const defaultDpi = useSelector(selectDefaultDpi);
  const defaultOption = dpiOptions.find((o) => o.value === defaultDpi);
  const [dpi, setDpi] = useState(defaultOption);
  const [selectedImageType, setSelectedImageType] = useState();
  const hasDpiOptions = Boolean(dpiOptions.length);
  const [resolutionExceedMsg, setResolutionExceedMsg] = useState('');
  const [showUpgradePopUp, setShowUpgradePopUp] = useState(false);
  const renderingPriceInfo = useSelector(selectRenderingPriceInfo);
  const availableBalance = useSelector(selectOrgAvailableBalance);
  const isRenderAmountSufficient = useSelector(selectIsAmountForRenderSufficient);
  const pricePerImage = useSelector(selectPerImagePremiumPrice);
  const subscriptionPlanExpiredPerImagePrice = useSelector(
    selectSubscriptionPlanExpiredPerImagePrice
  );
  const pricePerUhdImage = useSelector(selectPerImageUhdPrice);
  const [priceForRendering, setPriceForRendering] = useState('');
  const [isCameraClicked, setIsCameraClicked] = useState(false);
  const gamificationTooltipData = useSelector(selectGamificationTooltipData);
  const { step } = gamificationTooltipData;
  const isOnboardingState = isUserOnboarding();
  const isActivePlanAI = useSelector(selectUserActivePlanSubscriptionAI);
  const [cameraListWithValues, setCameraListWithValues] = useState(cameraList);
  const allSegmentData = useSelector(selectSegmentData);
  const disabledModal = isOldSubscriptionUser || isOldPremiumUserWithNoPlan || false;
  const isAllowRender = (+availableBalance > +pricePerImage || +availableBalance === +pricePerImage) || isUnlimitedRendering;
  const available3DModelVariations = useSelector(selectAvailable3DModelVariationsWithoutDivide);
  const available3DModelUploadLimit = useSelector(selectAvailable3DModelUploadLimit);
  const availableModels = useMemo(
    () => (isNewSubscriptionPlan ? available3DModelUploadLimit : available3DModelVariations),
    [isNewSubscriptionPlan, available3DModelUploadLimit, available3DModelVariations]
  );

  const { trackCreateImageSubmit, trackCreateImagePopupClosed, trackHighResolutionOptionClicked } =
    userPilotEvents();

  const isEmailVerified = () => localStorage.getItem('is_email_verified') === 'true';

  useEffect(() => {
    getOrgBalanceAndRenderingPrice();
    dispatch(imagePaymentFormPopupActions.close());
    dispatch(setClientSubscriptionPlans());
    updateUserData();
  }, []);

  useEffect(() => {
    let timerId;
    setPriceAccordingToRes();
    if (cameraList.length && !selectedCameraIds.length && !isCameraClicked) {
      timerId = setTimeout(() => {
        setSelectedCameraId(cameraList?.[0]?.id || null);
        onCameraClick(cameraList?.[0]);
      }, 200);
    }
    if (isOnboardingState && cameraList.length && !selectedCameraIds.length) {
      toggleItem(cameraList[0]);
    }

    // for users who comes from the website, selecting the first camera automatically
    if (isUserComingFromWebsite() && cameraList.length && !selectedCameraIds.length) {
      const defaultCamera = cameraList?.length > 1 ? cameraList?.[1] : cameraList?.[0];
      timerId = setTimeout(() => {
        setSelectedCameraId(defaultCamera?.id || null);
        onCameraClick(defaultCamera);
        toggleItem(defaultCamera);
      }, 200);
    }

    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [selectedCameraIds, cameraList]);

  useEffect(() => {
    if (!resolutionExceedMsg) return;
    const timeId = setTimeout(() => {
      setResolutionExceedMsg('');
    }, [6000]);

    return () => clearTimeout(timeId);
  }, [resolutionExceedMsg]);

  useEffect(() => {
    if (defaultOption) {
      setDpi(defaultOption);
    }
  }, [defaultOption?.value]);

  useEffect(() => {
    if (isRender && isFreeUser() && selectedImageType === 'tiff' && !disabledModal) {
      setShowUpgradePopUp(true);
    }
  }, [selectedImageType, isOldSubscriptionUser, isOldPremiumUserWithNoPlan]);

  const selectedCamera = cameraList.find((c) => c.id === selectedCameraId);

  const isPreview = popupType === RP_TYPE.PREVIEW; // HIGH RESOLUTION / PREMIUM LICENSE
  const isRender = popupType === RP_TYPE.RENDER; // QUICK VIEW / NON COMMERCIAL LICENSE

  const showDPI = isRender;

  const noCreditsAndLicenseTab = isPreview && !isCreditsAvailable && showLicenseTab;
  const showLicenseInfo = isPreview && showLicenseTab;

  useEffect(async () => {
    let resoX;
    let resoY;
    if (isPreview) {
      resoX = getScaleResolution(selectedCamera)?.resolutionX;
      resoY = getScaleResolution(selectedCamera)?.resolutionY;
    } else {
      resoX = selectedCamera?.resoX;
      resoY = selectedCamera?.resoY;
    }
    if (resoX && resoY) {
      addDataToSegment([
        { key: 'resoX', value: resoX },
        { key: 'resoY', value: resoY },
      ]);
    }
  }, [isPreview, selectedCamera]);

  const getOrgBalanceAndRenderingPrice = async () => {
    let orgBalance = {};
    const data = await apiGetRenderingPriceInfo();
    const balance = await apiGetOrganizationBalance();
    if (typeof balance?.effective_balance === 'number') {
      orgBalance = { ...balance };
    }
    if (!data) return;
    const info = {
      ...data,
      premium: data.premium ? Number(data.premium) : 0,
      standard: data.standard ? Number(data.standard) : 0,
      uhd_price: data.uhd_price ? Number(data.uhd_price) : 0,
      expired_subscription_rate: data.expired_subscription_rate
        ? Number(data.expired_subscription_rate)
        : 0,
      ...orgBalance,
    };
    dispatch(imagePaymentFormPopupActions.setRenderingPriceInfo(info));
  };

  const setPriceAccordingToRes = () => {
    credits = freeCredits;
    let totalPrice = 0;
    const updatedCameraList = cameraList.map((val) => {
      if (selectedCameraIds.indexOf(val.id) !== -1) {
        const value = { ...val };
        const price = calcPrice(val);
        totalPrice = totalPrice + price;
        if (!price && isRender && isFreemiumOrOldSubscriptionUser) {
          value.is_payment = false;
        } else {
          value.is_payment = true;
        }
        return value;
      }
      return val;
    });
    setCameraListWithValues(updatedCameraList);
    totalPrice = decimals(totalPrice, 2);
    const isRenderAmountSufficient = availableBalance >= totalPrice;
    const remainingAmtForRender = !isRenderAmountSufficient ? totalPrice - availableBalance : 0;

    // here, we are showing only that amount on buy image button that user is spending to purchase the image/produce the image
    if (remainingAmtForRender > 0) {
      totalPrice = totalPrice - availableBalance;
    }

    if (
      !isRenderAmountSufficient &&
      isFreeUser() &&
      isRender &&
      !showLicenseTab &&
      !disabledModal
    ) {
      const lastPopupTime = localStorage.getItem(UPGRADE_POPUP_CURATOR);
      const moreThan5Minutes = Date.now() / 1000 - lastPopupTime > 300; // Show high resolution popup only after 5 minutes
      if (moreThan5Minutes) setShowUpgradePopUp(true);
    }

    const priceForRendering = isRenderAmountSufficient ? (
      <span className={styles.bold}>Create Image</span>
    ) : selectedCameraIds.length === 0 ? (
      <>
        <span className={styles.bold}>Buy</span> (${pricePerImage} per image)
      </>
    ) : (
      <>
        <span className={styles.bold}>Buy Image</span> (${totalPrice})
      </>
    );
    dispatch(imagePaymentFormPopupActions.setIsAmountForRenderSufficient(isRenderAmountSufficient));
    dispatch(imagePaymentFormPopupActions.setRemainingAmountForRender(remainingAmtForRender));
    dispatch(imagePaymentFormPopupActions.setTotalAmountForRender(totalPrice));
    setPriceForRendering(priceForRendering);
  };

  const calcPrice = ({ resoX, resoY }) => {
    if (!isFreemiumUser() && subscription_expiry) {
      // if(!availableBalance) return subscriptionPlanExpiredPerImagePrice ? subscriptionPlanExpiredPerImagePrice : pricePerImage * 2;

      return subscriptionPlanExpiredPerImagePrice
        ? subscriptionPlanExpiredPerImagePrice
        : pricePerImage * 2;
    }

    // in case of freemium user we are using free credits to create high-res renders if the resolution is within the specified limit
    if (
      isFreemiumOrOldSubscriptionUser &&
      credits &&
      isRender &&
      resoX <= FREE_CREDITS_RESOLUTION_LIMIT &&
      resoY <= FREE_CREDITS_RESOLUTION_LIMIT
    ) {
      credits = credits - 1;
      return 0;
    }
    if (resoX > MAX_RESOLUTION || resoY > MAX_RESOLUTION) {
      return pricePerUhdImage;
    }
    return pricePerImage;
  };

  const handleCameraClick = async (camera) => {
    addDataToSegment([
      { key: 'Camera_name', value: camera?.cameraName },
      { key: 'Camera_id', value: camera?.id },
    ]);
    setSelectedCameraId(camera.id);
    onCameraClick?.(camera);
    setIsCameraClicked(true);
  };

  const handleResolutionChange = (data, methodType) => {
    const { maxXRes, maxYRes } = getMaxResolution();
    const isLocked = lockedRatio || selectedCamera?.is_lock;

    let { resoX, resoY } = data;

    const _selectedCamera = { ...selectedCamera };
    if (methodType?.type !== 'change') {
      if (resoX < MIN_RESOLUTION) {
        resoX = MIN_RESOLUTION;
      }

      if (resoY < MIN_RESOLUTION) {
        resoY = MIN_RESOLUTION;
      }
    }

    if (isPreview && resoX > MAX_PREVIEW_RESOLUTION) {
      if (isLocked) {
        resoX = _selectedCamera.resoX;
        resoY = _selectedCamera.resoY;
      } else {
        resoX = MAX_PREVIEW_RESOLUTION;
      }
      setResolutionExceedMsg(`You cannot exceed the limit of ${MAX_PREVIEW_RESOLUTION}px.`);
    }

    if (isPreview && resoY > MAX_PREVIEW_RESOLUTION) {
      if (isLocked) {
        resoY = _selectedCamera.resoY;
        resoX = _selectedCamera.resoX;
      } else {
        resoY = MAX_PREVIEW_RESOLUTION;
      }
      setResolutionExceedMsg(`You cannot exceed the limit of ${MAX_PREVIEW_RESOLUTION}px.`);
    }

    if (isRender && resoX > maxXRes) {
      if (isLocked) {
        resoX = _selectedCamera.resoX;
        resoY = _selectedCamera.resoY;
      } else {
        resoX = maxXRes;
      }
      setResolutionExceedMsg(`You cannot exceed the limit of ${maxXRes}px.`);
    }

    if (isRender && resoY > maxYRes) {
      if (isLocked) {
        resoY = _selectedCamera.resoY;
        resoX = _selectedCamera.resoX;
      } else {
        resoY = maxYRes;
      }
      setResolutionExceedMsg(`You cannot exceed the limit of ${maxYRes}px.`);
    }

    // const valueInt = parseInt(value) || 0;
    onCameraResolutionChange(resoX, resoY, _selectedCamera.id, methodType);
  };

  const resetValues = () => {
    resetSelectedItems();
  };

  const isFreeUser = () => {
    // when user have the balance from admin dashboard then we need to allow the user to create renders
    // https://app.clickup.com/t/86dvh8pq2 - Nikhil saini
    if (isAllowRender) {
      return false;
    }
    return (
      !isPackOrganization &&
      !isUnlimitedRendering &&
      (!isPremiumUser() || (isPremiumUser() && (isActivePlanAI || subscription_expiry)))
    );
  };

  const handleSubmit = async (values) => {
    if (
      loading ||
      (!isBuilder && isRender && !isEmailVerified()) ||
      (!isBuilder &&
        isRender &&
        isFreeUser() &&
        selectedImageType === 'tiff' &&
        !isOldSubscriptionUser)
    ) {
      return;
    }

    let formValues = values;

    if (hasPermission(PERMISSION.CAN_MANAGE_DPI)) {
      if (!dpi?.value) {
        errorToast('Please select dpi');
        return;
      }
      formValues = { ...values, dpi: dpi?.value };
    }

    // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
    // and has no free credit
    if (
      !isBuilder &&
      (isFreemiumUser() || hideNewPlans) &&
      isRender &&
      !freeCredits &&
      !isAllowRender
    ) {
      openFormInCaseOfNewOrgAndFreemiumUser();
      return;
    }

    // Do not allowing unlimited rendering if
    // - the organization is not a pack organization, or
    // - the organization does not have unlimited rendering addons, or
    // - the organization is not a premium organization, or
    // - the organization is a premium user but their active plan is an AI plan or the subscription is expired
    if (!isBuilder && isFreeUser() && isRender) {
      dispatch(setCuratorLoader(false));
      setLoading && setLoading(true);
      await getOrgBalanceAndRenderingPrice();
      setPriceAccordingToRes();
      const useFreeCredits = isFreemiumOrOldSubscriptionUser && credits !== freeCredits;
      formValues.is_free_credit_use = useFreeCredits;
      formValues.is_stripe_payment = isRenderAmountSufficient ? false : true;
      if (!isRenderAmountSufficient && availableBalance > 0) {
        formValues.partial_stripe_payment = true;
        formValues.partial_credit_amount = availableBalance;
      }
    } else {
      formValues.is_stripe_payment = false;
    }
    // user is using free credits and also doing payment
    if (formValues?.is_free_credit_use && formValues?.is_stripe_payment) {
      const freeCameraIds = [];
      const paidCameraIds = [];
      cameraListWithValues.map((val) => {
        if (selectedCameraIds.indexOf(val.id) !== -1) {
          if (val?.is_payment) {
            paidCameraIds.push(val.id);
          } else {
            freeCameraIds.push(val.id);
          }
        }
      });
      const paidFormValues = { ...formValues };
      const freeFormValues = { ...formValues };
      delete paidFormValues?.is_free_credit_use;
      delete freeFormValues?.is_stripe_payment;
      delete freeFormValues?.partial_stripe_payment;
      delete freeFormValues?.partial_credit_amount;

      trackCreateImageSubmit({
        image_name: formValues?.name,
        dpi: formValues?.value,
        'Submit from': isBuilder ? 'Mattress Builder' : 'Curator',
        'Render type': isPreview ? 'Preview' : 'High Resolution',
      });

      onSubmit?.(freeFormValues, freeCameraIds, resetValues, () => {
        dispatch(setCuratorLoader(false));
        setLoading && setLoading(true);
        onSubmit?.(paidFormValues, paidCameraIds, resetValues);
      });
      return;
    }
    onSubmit?.(formValues, selectedCameraIds, resetValues);
  };

  const handleFreeCreditsSubmit = () => {
    let formValues = {};

    formValues = {
      is_free_credit_use: true,
    };

    onSubmit?.(formValues, selectedCameraIds, resetValues);
  };

  const handleClose = () => {
    if (loading) {
      errorToast('Please wait...');
      return;
    }

    trackCreateImagePopupClosed({
      // TODO: Add more data here
    });

    onClose();
  };

  const handleResolutionPresetClick = (item) => {
    if (
      isPreview &&
      (item.width > MAX_PREVIEW_RESOLUTION || item.height > MAX_PREVIEW_RESOLUTION)
    ) {
      setResolutionExceedMsg(`You cannot exceed the limit of ${MAX_PREVIEW_RESOLUTION}px.`);
    }
    onCameraResolutionChange(item.width, item.height, selectedCamera.id);
    addDataToSegment([{ key: 'Quality', value: item?.name }]);
  };

  const calcWidthInInches = (size) => decimals(size / dpi?.value, 2);
  const handleDpiChange = (option) => {
    setDpi(option);
  };

  const toggleModelType = (type) => {
    dispatch(setOpen(type));

    resetSelectedItems();
    setSelectedCameraId(cameraList?.[0]?.id);
    setResolutionExceedMsg('');
  };

  const helpIcon = () => {
    return (
      <ElipsisTooltip
        title={
          isNewSubscriptionPlan
            ? 'Saving a mattress consumes 1 model from your 3D model upload limit' 
            : 'Saving a mattress consumes 1 model variation from your remaining count'
        }
        className={styles.tooltip}
        alwaysShow>
        {(props) => (
          <span className={`${styles.infoIcon} pointer`} {...props}>
            <HelpIconQuestionMark />
          </span>
        )}
      </ElipsisTooltip>
    );
  };

  const addDataToSegment = (arr) => {
    if (arr.length) {
      const dataToPass = allSegmentData ? allSegmentData : {};
      const copyData = JSON.parse(JSON.stringify(dataToPass));
      for (let i = 0; i < arr.length; i++) {
        const { key, value } = arr[i];
        copyData[key] = value;
      }
      dispatch(setSegmentData(copyData));
    }
  };

  const getScaleResolution = (selectedCam) => {
    if (!selectedCam) return null;

    const { resoX, resoY } = selectedCam;
    const { x, y } = scaleResolution({ x: resoX, y: resoY, max: MAX_PREVIEW_RESOLUTION });
    const resolutionX = parseInt(x);
    const resolutionY = parseInt(y);

    return {
      resolutionX,
      resolutionY,
    };
  };

  const handleTemplateClick = (template) => {
    if (!builderWithTemplates?.selected) return;
    const alreadyExists = builderWithTemplates?.selctedTemplates?.find(
      (item) => item?.id === template?.id
    );
    let templates = [...builderWithTemplates?.selctedTemplates];

    if (alreadyExists) {
      templates = builderWithTemplates?.selctedTemplates?.filter(
        (item) => item?.id !== template?.id
      );
    } else {
      templates.push(template);
    }
    setBuilderWithTemplates({ ...builderWithTemplates, selctedTemplates: templates });
  };

  const buttonTitle =
    (isBuilder ||
      isFreemiumOrOldSubscriptionUser ||
      (isPremiumUser() && (isActivePlanAI || subscription_expiry))) &&
    isRender ? (
      isBuilder || isPackOrganization || isUnlimitedRendering ? (
        <span className={styles.bold}>Create Image</span>
      ) : isFreemiumOrOldSubscriptionUser && !!freeCredits && isRenderAmountSufficient ? (
        'Create Image'
      ) : (
        priceForRendering
      )
    ) : !isBuilder && showLicenseTab && !hideFreeLicenseView ? (
      <>
        <span className={styles.bold}>Remove watermark</span> ({freeCredits} free images remaining)
      </>
    ) : (
      <span className={styles.bold}>Create Image</span>
    );

  const showInsufficientMsgIfBalanceAvailable =
    !isPremiumUser() && isRender && !isRenderAmountSufficient && availableBalance > 0;

  return (
    <>
      <Modal
        show={show}
        backdrop={isOnboardingState ? 'static' : true}
        onHide={handleClose}
        backdropClassName={styles.backdrop}
        onBackdropClick={handleClose}
        dialogClassName={cx(styles.modalDialog, dialogClassName)}
        contentClassName={cx(styles.modalContent, contentClassName)}>
        <Modal.Body>
          {/* <h5 className={cx(styles.title, 'mb-3')}>{title}</h5> */}
          {!isBuilder && (
            <div
              className={cx(
                styles.insufficientMsg,
                showInsufficientMsgIfBalanceAvailable && styles.show,
                !showLicenseTab && styles.posBottom
              )}>
              <span className={styles.bold}>Insufficient Balance!</span>&nbsp;Your wallet has only $
              {availableBalance} left & is adjusted in final amount.
            </div>
          )}

          {/* Templates */}
          {/* TODO: Remove builderWithTemplates?.opened logic after confirmation. Getting changes not final */}
          {isBuilder &&
          hasPermission(PERMISSION.CAN_GENERATE_MATTRESS_RENDER_WITH_TEMPLATE) &&
          templatesData?.length > 0 ? (
            !builderWithTemplates?.opened ? (
              <div
                className={styles.builderTemplates}
                onClick={() => setBuilderWithTemplates({ ...builderWithTemplates, opened: true })}>
                <div className={styles.icons}>
                  <LeftArrowIconV3 />
                  <LeftArrowIconV3 style={{ marginLeft: '-1rem' }} />
                </div>
                <span>Try your mattress in styled rooms</span>
              </div>
            ) : (
              <div className={styles.expandedBuilderTemplates}>
                <div className={styles.container}>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="form-check custom-checkbox" style={{ minHeight: 0 }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={builderWithTemplates?.selected}
                        style={{ width: '20px', height: '20px' }}
                        disabled={builderWithTemplates?.libraryData?.data?.id}
                        onChange={(e) => {
                          e.stopPropagation();
                          setBuilderWithTemplates({
                            ...builderWithTemplates,
                            selected: !builderWithTemplates.selected,
                          });
                        }}
                      />
                    </div>
                    <span>
                      Save to library & Try your mattress in styled rooms —{' '}
                      <span className={styles.bold}>choose your look!</span>
                    </span>
                  </div>

                  <div className="d-flex justify-content-start align-items-center">
                    {helpIcon()}
                    <span className="ms-1">Models Available: {availableModels || 0}</span>
                  </div>

                  {builderWithTemplates?.libraryData?.data?.name ? (
                    <span>{builderWithTemplates?.libraryData?.data?.name}</span>
                  ) : null}

                  {/* Add to library name  */}
                  {builderWithTemplates?.selected &&
                  !builderWithTemplates?.libraryData?.data?.id ? (
                    <Input
                      value={builderWithTemplates?.propName}
                      placeholder="Enter mattress name"
                      limit={CONFIGURATOR_NAME_MAX_LENGTH}
                      style={{
                        width: '80%',
                        borderRadius: '4px',
                        padding: '0.5rem',
                        lineHeight: '0.5rem',
                      }}
                      onChange={({ value }) => {
                        const name = sanitizeNameInConfigurator(value, {
                          maxLength: CONFIGURATOR_NAME_MAX_LENGTH,
                        });
                        setBuilderWithTemplates({ ...builderWithTemplates, propName: name });
                      }}
                    />
                  ) : null}

                  <div
                    className={cx(
                      styles.templates,
                      !builderWithTemplates?.selected || !builderWithTemplates?.propName
                        ? styles.disabled
                        : ''
                    )}>
                    {templatesData?.map((item, index) => (
                      <div
                        key={item.id}
                        className={cx(
                          styles.template,
                          builderWithTemplates?.selctedTemplates?.find(
                            (_item) => _item?.id === item?.id
                          )
                            ? styles.active
                            : ''
                        )}
                        onClick={() => handleTemplateClick(item)}>
                        <img src={item.thumbnail} alt="template-logo" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          ) : null}

          <div
            className={cx('d-flex justify-content-evenly align-items-center mt-1 mb-3')}
            style={{
              padding: '0 4em',
            }}>
            {!hideFreeLicenseView ? (
              <div className="form-check custom-checkbox d-flex align-items-center">
                <input
                  className={cx('form-check-input', styles.darkCheckBg)}
                  type="checkbox"
                  name="quickView"
                  checked={isPreview}
                  onChange={() => {
                    addDataToSegment([{ key: 'is_preview', value: true }]);
                    toggleModelType(RP_TYPE.PREVIEW);
                  }}
                />
                <span>{showLicenseTab ? 'Non Commercial' : 'Preview'}</span>
              </div>
            ) : null}
            <div
              className={`form-check custom-checkbox d-flex align-items-center ${
                isOnboardingState && 'blurInput'
              }`}>
              <input
                className={cx('form-check-input', styles.darkCheckBg)}
                type="checkbox"
                name="quickView"
                checked={isRender}
                onChange={() => {
                  addDataToSegment([{ key: 'is_preview', value: false }]);

                  trackHighResolutionOptionClicked({});

                  if (isGuestLogin) {
                    dispatch(setSignupPopOpen(true));
                    dispatch(setSignupPopOpenedFrom('high-resolution-image'));
                    return;
                  }
                  toggleModelType(RP_TYPE.RENDER);
                }}
              />
              <span>
                {showLicenseTab ? 'Premium License' : 'High Resolution'}{' '}
                <ColouredCrownIcon style={{ marginLeft: 8 }} />
              </span>
            </div>
          </div>
          {!isOnboardingState && (
            <button className={cx(styles.closeButton, styles.btn1)} onClick={handleClose}>
              <CloseIconSmall />
            </button>
          )}
          <div className={cx(styles.container, showLicenseInfo && styles.containerColumn)}>
            {noCreditsAndLicenseTab ? (
              <>
                <div className={styles.noCreditView}>
                  <h2>Sorry you don't have any free image left</h2>
                  <p>
                    Need more free images?
                    <br />
                    Invite friends and receive free images when they join imagine.io.
                  </p>
                  <div className={styles.actionBtn}>
                    <Button
                      color="warning"
                      className={cx('w-100 lf-btn-5')}
                      size="xlg"
                      onClick={() => dispatch(openInvite())}>
                      <span className={styles.bold}>Invite Friends</span>
                    </Button>
                    <span>or</span>
                    <Button
                      color="warning"
                      className={cx('w-100 lf-btn-1')}
                      size="xlg"
                      onClick={() => dispatch(setOpen(RP_TYPE.RENDER))}>
                      <span className={styles.bold}>Buy Image</span>
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  className={cx(
                    styles.renderCameraListContainer,
                    showLicenseTab && styles.freeCredits,
                    isPreview &&
                      !showLicenseTab &&
                      !isOnboardingState &&
                      styles.previewCameraListContainer,
                    isPreview &&
                      showLicenseTab &&
                      !hideFreeLicenseView &&
                      cameraList.length < 3 &&
                      styles.nonCommercialLicense,
                    isOnboardingState && styles.previewOnboardingState
                  )}>
                  <CameraList
                    className={styles.renderCameraList}
                    cameraList={cameraList}
                    selected={selectedCameraIds}
                    allSelected={allSelected}
                    onToggleAll={toggleAll}
                    onToggle={toggleItem}
                    isPreview={isPreview}
                    selectedCameraId={selectedCameraId}
                    onCameraClick={handleCameraClick}
                  />
                </div>
                {!showLicenseInfo ? (
                  <div style={{ width: 311, maxHeight: 467 }}>
                    {resolutionPresets?.length > 0 && (
                      <div className={`d-flex gap-2 justify-content-between mb-3`}>
                        {resolutionPresets.map((item, idx) => {
                          const active =
                            item.width === selectedCamera?.resoX &&
                            item.height === selectedCamera?.resoY;
                          return (
                            <Button
                              color="default"
                              className={styles.presetButton}
                              textClassName={styles.presetButtonText}
                              onClick={() =>
                                isOnboardingState ? {} : handleResolutionPresetClick(item)
                              }
                              active={active}
                              size="xs"
                              disabled={!selectedCamera}
                              key={idx}>
                              {item?.name}
                            </Button>
                          );
                        })}
                      </div>
                    )}

                    {/* {isRender && ( */}
                    <LockedInput
                      key={selectedCamera?.id}
                      id="render-popup-locked-input"
                      className="mb-3"
                      // inputClassName={styles.textInput}
                      lock={lockedRatio || selectedCamera?.is_lock}
                      onLockToggle={() => onLockToggle(selectedCamera.id)}
                      value={[
                        {
                          name: 'resoX',
                          value: isPreview
                            ? getScaleResolution(selectedCamera)?.resolutionX
                            : selectedCamera?.resoX,
                          label: 'Width (px)',
                          disabled: !selectedCamera || isOnboardingState,
                          defaultValue: DEFAULT_CAMERA_PX_VALUE,
                        },
                        {
                          name: 'resoY',
                          value: isPreview
                            ? getScaleResolution(selectedCamera)?.resolutionY
                            : selectedCamera?.resoY,
                          label: 'Height (px)',
                          disabled: !selectedCamera || isOnboardingState,
                          defaultValue: DEFAULT_CAMERA_PX_VALUE,
                        },
                      ]}
                      onChange={handleResolutionChange}
                      // normalizeOnExeedsLimit
                      normalizeOnBlur
                      min={MIN_RESOLUTION}
                      // max={MAX_RESOLUTION} // Max is handled in different way
                      valueFormatter={parseInt}
                      onlyIntegers
                      // enableSimpleBlur
                      inputContainerClassName={styles.resolutionInput}
                      errorMessage={resolutionExceedMsg}
                    />
                    {/* )} */}
                    {showDPI && (
                      <PermissionArea name={PERMISSION.CAN_MANAGE_DPI}>
                        <div className="d-flex justify-content-between mb-3">
                          <div style={{ width: 124 }}>
                            <SelectFormGroupV2
                              label="DPI"
                              options={dpiOptions}
                              value={dpi}
                              onChange={handleDpiChange}
                              placeholder=""
                              theme="dark"
                              menuZIndex={2000}
                              loading={!hasDpiOptions}
                              customStyle={{
                                dropdownIndicator: (styles) => ({
                                  background: `url(${dropdownArrow}) no-repeat center center`,
                                }),
                              }}
                            />
                          </div>
                          {selectedCamera && (
                            <div className={styles.inchesSizeLabel}>
                              {calcWidthInInches(selectedCamera.resoX)}in x{' '}
                              {calcWidthInInches(selectedCamera.resoY)}in
                            </div>
                          )}
                        </div>
                      </PermissionArea>
                    )}
                    <PreviewRenderForm
                      className={styles.previewRenderForm}
                      type={popupType}
                      onSubmit={handleSubmit}
                      loading={loading}
                      isSiloRoom={isSiloRoom || isBuilder}
                      hasMetadata={!isBuilder && isRender && hasMetadata}
                      allowWatermark={!isBuilder && isRender}
                      isRender={isRender}
                      disableImageType={isPreview}
                      buttonTitle={buttonTitle}
                      hideFormButton={true}
                      resetForm={isRender}
                      addDataToSegment={addDataToSegment}
                      setSelectedImageType={setSelectedImageType}
                      // isAutomation={isAutomation}
                    />
                  </div>
                ) : null}
              </>
            )}
          </div>
          {(isBuilder || !noCreditsAndLicenseTab) && (
            <div
              ref={(elem) => {
                if (step === 'PRODUCE_IMAGE' && elem && isOnboardingState) {
                  setTooltipData({
                    target: elem,
                  });
                }
              }}>
              <Button
                color="warning"
                className={cx(
                  'mt-3 w-100 lf-btn-1',
                  isOnboardingState && step === 'PRODUCE_IMAGE' && 'hightlightOnboarding'
                )}
                size="xlg"
                loading={loading}
                disabled={
                  loading ||
                  (isRender && !isEmailVerified()) ||
                  (isRender &&
                    isFreeUser() &&
                    selectedImageType === 'tiff' &&
                    !isOldSubscriptionUser)
                }
                onClick={() => {
                  const btn = document.querySelector('#produceImageFormButton');
                  if (btn) {
                    btn.click();
                    return;
                  }
                  if (
                    !isBuilder &&
                    isFreemiumOrOldSubscriptionUser &&
                    isPreview &&
                    showLicenseTab
                  ) {
                    handleFreeCreditsSubmit();
                    return;
                  }
                }}>
                {buttonTitle}
                {!isBuilder &&
                  isFreemiumOrOldSubscriptionUser &&
                  !!freeCredits &&
                  isRender &&
                  isRenderAmountSufficient && (
                    <div className={styles.creditsLabel}>{`(${freeCredits} free ${
                      freeCredits === 1 ? 'image' : 'images'
                    } left)`}</div>
                  )}
              </Button>
            </div>
          )}
          {!getLocalStorage(EMAIL_VERIFIED, true) && isRender ? (
            <div className={'mt-3 d-flex justify-content-center gap-3'}>
              <span>
                Verify email for High Resolution images -{' '}
                <a className={styles.buyLink} onClick={handleResend}>
                  Resend verification mail !
                </a>
              </span>
            </div>
          ) : !isBuilder && isFreemiumUser() && isRender ? (
            <div className={'mt-3 d-flex justify-content-center gap-3'}>
              <span>
                Checkout our subscription plans & save money -{' '}
                <a
                  className={styles.buyLink}
                  onClick={() => {
                    if (hideNewPlans || isFreemiumUser()) {
                      // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
                      openFormInCaseOfNewOrgAndFreemiumUser();
                      return;
                    }
                    navigateToUpgradePlan({
                      browsePlan: true,
                      newTab: true,
                    });
                  }}>
                  Click Here
                </a>
              </span>
            </div>
          ) : null}
          {!isBuilder && showLicenseInfo && !noCreditsAndLicenseTab && <MoreInfo />}
        </Modal.Body>
      </Modal>
      {!isBuilder && showUpgradePopUp && !hideNewPlans && !isFreemiumUser() ? (
        <UpgradeForMore
          openInNewTab
          onClose={() => {
            localStorage.setItem(UPGRADE_POPUP_CURATOR, Date.now() / 1000);
            setShowUpgradePopUp(false);
          }}
        />
      ) : null}
    </>
  );
};
